import { connect } from "react-redux";
import InvoiceWindow from "../components/_InvoiceWindow";
import * as actions from "../../../_actions/order";

const mapStateToProps = ({ OrderInvoice, Misc }) => ({
    loading: OrderInvoice.fetching.loading,
    err: OrderInvoice.fetching.err,
    language: Misc.language.language,
    store: Misc.store.store
});

const mapDispatchToProps = dispatch => ({
    generateInvoice: (orderId, language, additionalInfo) => {
        dispatch(actions.generateInvoice(orderId, language, additionalInfo));
    },
    getOrder: id => {
        dispatch(actions.get(id));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceWindow);
